import { useMemo } from "react"
import { ConditionGroup } from "@/schema"

import { useInfiniteMeetingFeed } from "./queries"

const TWO_YEARS_MS = 2 * 365 * 24 * 60 * 60 * 1000
const SIX_MONTHS_MS = 6 * 30 * 24 * 60 * 60 * 1000

export function useMeetingsPageData(options?: {
  viewType?: "upcoming" | "processed"
  userIds?: string[]
  conditionGroup?: ConditionGroup
  search?: string
}) {
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  const twoYearsAgo = new Date(today.getTime() - TWO_YEARS_MS)
  const sixMonthsFromNow = new Date(today.getTime() + SIX_MONTHS_MS)

  const isProcessed = options?.viewType === "processed"

  const feedQuery = useInfiniteMeetingFeed({
    startDate: isProcessed ? twoYearsAgo : today,
    endDate: isProcessed ? today : sixMonthsFromNow,
    scope: isProcessed ? "processed" : undefined,
    userIds: options?.userIds,
    conditionGroup: options?.conditionGroup,
    search: options?.search,
    enabled: options?.viewType !== undefined,
  })

  const meetings = useMemo(() => feedQuery.data?.meetings ?? [], [feedQuery.data?.meetings])

  return {
    meetings,
    isLoading: feedQuery.isLoading,
    isFetchingNextPage: feedQuery.isFetchingNextPage,
    fetchNextPage: feedQuery.fetchNextPage,
    hasNextPage: Boolean(feedQuery.hasNextPage),
  }
}
